import { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { AddTeamMembersButton } from './AddTeamMembersButton';
import { CreateTeamButton } from './CreateTeamButton';
import { DeleteTeamButton } from './DeleteTeamButton';
import { EditTeamButton } from './EditTeamButton';
import { InviteUserButton } from './InviteUserButton';
import { useRole } from '../../../hooks/useRole';
import { UsersAndTeamsPaths } from '../types';
export function UsersAndTeamsActions(props) {
    const { baseUrl, refetch } = props;
    const role = useRole();
    const canInvite = role.can('invite:user');
    return (<Switch>
      <Route exact path={[
            `${baseUrl}/${UsersAndTeamsPaths.users}`,
            `${baseUrl}/${UsersAndTeamsPaths.invites}`,
            `${baseUrl}/${UsersAndTeamsPaths.teams}`,
        ]}>
        {canInvite && <InviteUserButton onInviteCreated={refetch}/>}
        <CreateTeamButton />
      </Route>
      <Route path={`${baseUrl}/${UsersAndTeamsPaths.teams}/:teamId`} render={({ match }) => (<Fragment>
            <DeleteTeamButton teamId={match.params.teamId}/>
            <EditTeamButton teamId={match.params.teamId}/>
            <AddTeamMembersButton teamId={match.params.teamId}/>
          </Fragment>)}/>
    </Switch>);
}
